export const MAX_FILE_SIZE = 52428800; // 50MB
export const FILE_TYPES = {
    'video/*': [],
    'audio/*': [],
};
export const MOBILE_FOOTER_HEIGHT = 100;
